import { render, staticRenderFns } from "./TabDaftarMaterial.vue?vue&type=template&id=028af3d8&scoped=true"
import script from "./TabDaftarMaterial.vue?vue&type=script&lang=js"
export * from "./TabDaftarMaterial.vue?vue&type=script&lang=js"
import style0 from "./TabDaftarMaterial.vue?vue&type=style&index=0&id=028af3d8&prod&scoped=true&lang=css"
import style1 from "./TabDaftarMaterial.vue?vue&type=style&index=1&id=028af3d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028af3d8",
  null
  
)

export default component.exports